import React from "react";
import { Stack, Typography } from "@mui/material";

import { HubIcon } from "../../components";

import { InfoStack } from "./styles";

const LaborType = ({ isSubRoute }) => {
  const label = isSubRoute ? "Subroute (Subruta)" : "Partial (Parcial)";
  const sublabel = isSubRoute
    ? "This labor ticket is for rework on a route."
    : "This labor ticket is completing a partial amount, more parts may be coming.";
  const spanishLabel = isSubRoute
    ? "(Este ticket es para retrabajar una ruta.)"
    : "(Este ticket es para completar una cantidad parcial, es posible que vengan más partes.)";

  return (
    <InfoStack>
      <HubIcon icon="Info" />
      <Stack alignItems="start" justifyContent="center" gap="0px">
        <Typography variant="boldCaptionL">{label}</Typography>
        <Typography variant="caption">{sublabel}</Typography>
        <Typography variant="caption">{spanishLabel}</Typography>
      </Stack>
    </InfoStack>
  );
};

export default LaborType;
